import React from 'react';
import ReactDOM from 'react-dom/client';
import RootApp from './App';
import 'antd/dist/reset.css';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
// Design system styles
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RootApp />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
